import React from 'react';
import { Form } from 'react-bootstrap';

const shapeOptions = [
  { key: 'circle', label: 'Circle' },
  { key: 'crossline', label: 'Crossline' },
  { key: 'polygon', label: 'Polygon' },
];

const TourToolsPanel = ({
  mapTool,
  setMapTool,
  showTourTools = true,
  setShowTourTools = () => {},
  stacked = false,
  style = {},
  fullWidth = false,
}) => {
  const activeMode = mapTool?.mode || mapTool;
  const activeShape = mapTool?.geometry || null;

  const selectShape = (shape) => {
    if (activeMode === 'checkpoint' && activeShape === shape) {
      setMapTool(null);
      return;
    }
    setMapTool({ mode: 'checkpoint', geometry: shape });
  };

  const toggleStart = () => {
    if (activeMode === 'start') {
      setMapTool(null);
      return;
    }
    setMapTool({ mode: 'start' });
  };

  return (
    <div
      className="trip-tools-panel"
      style={{
        width: fullWidth ? '100%' : 260,
        minWidth: fullWidth ? 0 : 260,
        marginBottom: stacked ? 0 : 16,
        position: stacked ? 'static' : undefined,
        ...style,
      }}
      id="tools-panel"
    >
      <div className="trip-tools-header d-flex justify-content-between align-items-center">
        <span>Tour Tools</span>
        <Form.Check
          type="switch"
          id="toggle-tools"
          checked={showTourTools}
          onChange={(e) => setShowTourTools(e.target.checked)}
          title="Show/hide tour tools"
        />
      </div>

      <div className="trip-tools-section">
        <div className="trip-tools-label">Add checkpoint</div>
        <div className="trip-tools-grid">
          {shapeOptions.map((opt) => (
            <button
              key={opt.key}
              type="button"
              className={`trip-tool responder-interactive-action ${
                activeMode === 'checkpoint' && activeShape === opt.key ? 'active is-selected' : ''
              }`}
              aria-pressed={activeMode === 'checkpoint' && activeShape === opt.key}
              onClick={() => selectShape(opt.key)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="trip-tools-section">
        <div className="trip-tools-label">Start point</div>
        <button
          type="button"
          className={`trip-tool responder-interactive-action ${
            activeMode === 'start' ? 'active is-selected' : ''
          }`}
          aria-pressed={activeMode === 'start'}
          onClick={toggleStart}
        >
          Set starting point
        </button>
      </div>

      <div className="trip-tool-hint">
        Click the map to place. Driving/walking snap to roads; indoor stays free.
      </div>
    </div>
  );
};

export default TourToolsPanel;
